import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from '@/contexts/AuthContext';
import { PageLoader } from '@/components/Common/PageLoader/PageLoader';
import { TermsOfServiceDialog } from '@/components/Authentication/TermsOfServiceDialog';
import { getCookie, ONE_YEAR_SECONDS, setCookie } from '@/services/cookiesService';
import { getSafeRedirectPath } from '@/utils/urls';
import { log } from '@/logger/logger';
import { IDP_INITIATED_REDIRECT_PATH } from '@/consts/auth.consts';

const PROMO_END_DATE = new Date('2026-04-24T00:00:00Z');
const PROMO_TERMS_URL = 'https://www.figma.com/figma-weave-promo-terms/';

const TERMS_OF_SERVICE_ACCEPTED_COOKIE = 'weavy_tos_accepted';

const isTermsOfServiceAccepted = () => getCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE) === 'true';
const setTermsOfServiceAccepted = () =>
  setCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE, 'true', { maxAge: ONE_YEAR_SECONDS });

const logger = log.getLogger('IdpInitiatedSignInPage');

export function IdpInitiatedSignInPage() {
  const { initiateRedirectSignIn, signOut } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  const proceedToOAuth = () => signOut().then(() => initiateRedirectSignIn('figma', '/signin'));

  useEffect(() => {
    const redirectPath = getSafeRedirectPath(searchParams.get('redirect_path'));
    sessionStorage.setItem(IDP_INITIATED_REDIRECT_PATH, redirectPath);

    const promotion = searchParams.get('promotion');
    const isFigmaWeavePromoExpired = promotion === 'figma_weave_promo' && new Date() >= PROMO_END_DATE;
    if (isFigmaWeavePromoExpired) {
      logger.info('Expired Figma Weave promo sign-in redirect', { promotion, redirectPath });
      window.location.href = PROMO_TERMS_URL;
      return;
    }

    const tosAlreadyAccepted = isTermsOfServiceAccepted();

    if (tosAlreadyAccepted) {
      void proceedToOAuth();
    } else {
      setShowTermsOfService(true);
    } // eslint-disable-next-line react-hooks-js/exhaustive-deps
  }, [initiateRedirectSignIn, searchParams, signOut]);

  const handleTermsOfServiceAccept = () => {
    setTermsOfServiceAccepted();
    setShowTermsOfService(false);
    void proceedToOAuth();
  };

  if (showTermsOfService) {
    return <TermsOfServiceDialog onAccept={handleTermsOfServiceAccept} />;
  }

  return <PageLoader />;
}
